<template>
  <div class="container">
          <div class="select_nav">
                <div class="select_nav_item" v-for="(item,index) in unitArr"   :key="index">
                      <span :class="['select_item_text',index==showLength-1?'selected_item_text':'']">{{item}}</span>
                </div>
          </div>
           <!-- 数据列表 -->
          <div class="select_list">
                  <div class="select_list_div"  >
                     <div class="select_list_div1" v-for="(item,index) in repairTypeData" :key="index" @click="listSelect(1, index,item)" >
                            <span :class="['list_text',item.flag?'selected_item_text':'']" >{{item.repairType}}</span>
                            <img v-if="item.flag" class="xj_icon" :src="bxType" >
                      </div>
                  </div>
                  <div class="select_list_div">
                        <div class="select_list_div1" v-for="(vitem,vindex) in childrenRepairTypeData" :key="vindex" @click="listSelect(2,vindex,vitem)">
                            <span :class="['list_text',vitem.flag?'selected_item_text':'']">{{vitem.repairType}}</span>
                            <img v-if="vitem.flag" class="xj_icon" :src="bxType" >
                        </div>
                 </div>
          </div>


  </div>
</template>

<script>
import storage from '../../utils/storage'
import {
  callSpaceUp
} from '../../utils/api';
import {
  mapState
} from 'vuex';
export default {
  name:"success",
    computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common
    })
  },
  data () {
    return {
      bxType:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzpJREFUWAntlstrE1EUxr+bTDKT0AeKm4q4FDfd+B+47cbSRzA2WB+gKFYULaKCdtWFCkotlaJSUZqW4kaRuhAUwXYhCCJoKVJ0ISpWtNZXJs3M8ZxJJ05mGm1LsxBzITP3zpxzfud+99w7ASqtosD/okDNCK2OjdB6/3xD/gflGOuD1GBaGLMJj/U0ncEo6S5HczvlusfT1GiFcA0h1MJmShSdxgysDHBcmGVVIJamZgu4zpxazPGVB/IjwjZZEh6VLwGGJ+z8zKsdsNCkhZ3r1GwVvkuvLAowPMnwAY5fVQSP8JMsJkmhAw3KlATy+UhvhZqRphQDrnC4uLPmblyBW5ggG83ZNvXCfazczkrcjUHaQSFc4lhGAJ7Dc2hoNhNq0ssq2gXxG1RnadjCRfI+m8QtKEVe4z/1Gb6b4X1sEw3ALTwDoYXhL/0xCgrow7SBHW9CRz1ybJZDrxnBESRU1u/kHzN8D4VxkSFBeA5PudJazK1qyu8n43wRysFgo5fd68Eb1CmcCA7oFi6g5/ehsVAAPlj2M7x3IbjK4YnS0FQKXkigepqrFdhYqFgRXvZtGPuia9CPATLE2N+42jt4Cj0MjxTJHgWUhXFlozGTUK/8ft6xo8DXdnzi1U47ehQWhc04CZ5Bu6Hj8rpxinkdY4N0mLfaeYaHA/A5POLArT9T6o3XZ6H+/DmgKLMKpxnYx5XKVI8pJ0EaUh9f4+raforLG5a9k+HnSsAfhjW0/kiqt54oJbteFNBPEb2GA4dx0ClE7x7gfczlOGQrTKgQujhiqGjm8nnJ4n7EQPJbk/pQkuh7UZyAvHxAmv4OZ1mJQ4Ek3GNLPire5HjNWb17ZgZt2KWmJcxi2/wSeMw3q5yp4SgXpChRvBzzH5MiOM+cq/1udA7JpcKFGlTAzYUoZAyjmw+XY87u8M7YtZGZ53DHsLH9S5v67D5eyj2ogOutlJ2ZxAmeXXdACbEReBaj8TBSy4VLmNIKyFtpRMoYQhcrccqRXpTIw2/HTLTP7FQzjt0yL39PYD4wf+VOchLyLybGB8xIxsZepNTsMrkFt0UnIB7xYdpk26jO1GEMXKyFKJVORYF/WYFfH7EPfs19vPoAAAAASUVORK5CYII=',
      unitArr:['选择一级类型','选择二级类型'],
      showLength:1,
      repairSelectType:"",
      repairTypeData:'',
      childrenRepairTypeData:'',
      repairTypeData_1:'',
      repairTypeData_2:'',
      selectObject:{
          repairType:'',
          repairTypeId:'',
          tworepairType:'',
          tworepairTypeId:'',
      },
    }
  },
  created () {
    this.repairSelectType =  this.$route.query.repairSelectType
    this.getRepairType();
  },
  methods: {
    back(){
      storage.setS("repairSelectType",JSON.stringify(this.selectObject))
      this.$router.go(-1)
    //   window.history.back(-1);
    },
    getRepairType() {
      // let parmes = {
      //   companyId: this.common.marketInfo.cityId,
      //   url: "/property/rstRepair/queryFirstRepairType"
      // }
      let parmes = {
        companyId: this.common.marketInfo.cityId,
        url: "/property/rstRepair/queryRepairType"
      }
      callSpaceUp(parmes).then(res => {
        if (res.res.code == 10000) {
          let repairType = res.body.data || []
        //   console.log("in repairType ==== " + JSON.stringify(repairType))
          let repairTypeData_1 = [], repairTypeData_2 = [];
          // 报修类型数据 type = 1 或者3  //投诉建议数据 type = 2

          repairType.forEach(item => {
            if (item.type == 1 || item.type == 3 ) {
              repairTypeData_1.push(item)
            } else {
              repairTypeData_2.push(item)
            }
          })
          this.repairTypeData_1 = repairTypeData_1;
          this.repairTypeData_2 = repairTypeData_2;
          if(this.repairSelectType==1){
               this.repairTypeData = this.repairTypeData_1
          }else{
              this.repairTypeData = this.repairTypeData_2
          }

        }
      });
    },
    clickNav(ceng,item){
        let self = this;
        self.showLength = ceng+1
    },
    listSelect(ceng, index,item){

        var list =[];
        if(ceng==1){
           list = this.repairTypeData;
        }else if(ceng ==2){
           list = this.childrenRepairTypeData;
        }

         var item1 = list[index];
         for(var i=0;i<list.length;i++){
            list[i].flag=false;
         }
         item1.flag=true;
        //  console.log("item === " +JSON.stringify(item1))
         if(ceng==1){
            // this.oneItem =item1;
             this.selectObject.repairType =item1.repairType;
             this.selectObject.repairTypeId =item1.id;
             this.selectObject.tworepairType='';
             this.selectObject.tworepairTypeId ='';
            if(item1.children.length>0){
              var ulist =[];
              ulist.push(item1.repairType);
              ulist.push("选择二级类型")
              this.unitArr=ulist;
              this.childrenRepairTypeData=item1.children;
            //   console.log("childrenRepairTypeData === " +JSON.stringify(this.childrenRepairTypeData))
              this.showLength =ceng+1;
            }else{
               //选择完成
              // repair_type_id,item.
              //    this.activeType(item1.repair_type_id,this.oneItem.repair_type_name)
              this.back();
            }
         }else if(ceng ==2){
                this.selectObject.tworepairType=item1.repairType;
                this.selectObject.tworepairTypeId =item1.id;
                var ulist2 =[];
                ulist2.push(this.unitArr[0]);
                ulist2.push(item1.repairType);
                this.unitArr=ulist2;
                this.back();
                // this.threeList =item1.threeList;
               //选择完成
            //    this.activeType(item1.repair_type_id,this.oneItem.repair_type_name+"-"+this.twoItem.repair_type_name)
            //  }

         }

     },


  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
    .select_nav{
      width: 710px;
      margin-top: 20px;
      margin-left: 20px;
      height:98px;
      display: flex;
      border-bottom-width:2px;
      border-bottom-color:#f0f0f0;
      flex-direction:row;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      background-color: #ffffff;
    }
    .select_nav_item{
      margin-left:40px;
      width: 210px;
      height:98px;;
      flex-direction:row;
      justify-content:space-between;
      align-items:center;
    }
    .lastItem{
      height:96px;
      position:relative;
    }
    .xj_icon{
      width:32px;
      height:32px;
      display:block;
      position:absolute;
      right:10px;
      top:32px;
    }

    .select_item_text{
      color:#999;
      font-size:28px;
      line-height:96px;
    }

    .select_item_icon{
      width:40px;
      height:6px;
    }
    .select_list{
      width: 710px;
      display: flex;
      background-color: #ffffff;
      margin-left: 20px;
      flex-direction: row;

    //   height:1000px;
      margin-bottom: 20px;
    }
    .select_list_div{
        width: 250px;
        flex-direction: column;
    }
      .select_list_div1{
        width: 250px;
        flex-direction: row;
        position: relative;
    }
    .select_list_item{
      flex-direction:row;
      justify-content:space-between;
      height:96px;
    }
    .list_text{
      line-height:96px;
      height:96px;
      color:#222;
      font-size:28px;
    }
    .list_icon{
      width:48px;
      height:48px;
      margin-top:24px;
    }
     .selected_item_text{
        font-size:28px;
       line-height:96px;
      height:96px;
      color:#06A5FF;
    }


</style>
